export default __webpack_public_path__ + "static/media/Snd5.fd0c5e48.mp3";